import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { SikoB2bCarouselComponent } from '@siko/features/product/product-carousels/swiper-carousel/swiper-carousel.component';
import { SikoB2bRecommendationStateService } from '@siko/features/recommendation/recommendation-state.service';
import { SikoB2bProduct } from '@siko/models/product.model';
import { I18nModule, RoutingService } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'siko-b2b-product-detail-last-seen-carousel',
   templateUrl: './last-seen-carousel.component.html',
   imports: [I18nModule, SikoB2bCarouselComponent, AsyncPipe],
   host: {
      class: 'w-100'
   },
})
export class SikoB2bProductDetailLastSeenCarouselComponent {
   readonly recommendationStateService = inject(SikoB2bRecommendationStateService);

   readonly routingService = inject(RoutingService);

   filteredProducts$: Observable<SikoB2bProduct[]> = combineLatest([
      this.recommendationStateService.productDetailLastSeenProducts$,
      this.routingService.getRouterState(),
   ]).pipe(
      map(([products, routerState]) => {
         const currentCode = String(routerState.state.params.productCode);

         return products.filter(product => products.length === 1 || product.code !== currentCode);
      })
   );
}
